'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = require('react');
var rcUtil = require('rc-util');

function noop() {}

function isValueNumber(value) {
  return (/^-?\d+?$/.test(value + '')
  );
}

function preventDefault(e) {
  e.preventDefault();
}

var InputNumber = React.createClass({
  displayName: 'InputNumber',

  propTypes: {
    onChange: React.PropTypes.func
  },

  getInitialState: function getInitialState() {
    var value = undefined;
    var props = this.props;
    if ('value' in props) {
      value = props.value;
    } else {
      value = props.defaultValue;
    }
    return {
      value: value,
      focused: props.autoFocus
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      prefixCls: 'rc-input-number',
      max: Infinity,
      min: -Infinity,
      style: {},
      defaultValue: '',
      onChange: noop
    };
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      this.setState({
        value: nextProps.value
      });
    }
  },

  onChange: function onChange(event) {
    var props = this.props;
    var val = event.target.value.trim();
    if (!val) {
      this.setValue(val);
    } else if (isValueNumber(val)) {
      val = Number(val);
      if ('min' in props) {
        if (val < props.min) {
          return;
        }
      }
      if ('max' in props) {
        if (val > props.max) {
          return;
        }
      }
      this.setValue(val);
    }
  },

  onKeyDown: function onKeyDown(e) {
    if (e.keyCode === 38) {
      this.up(e);
    } else if (e.keyCode === 40) {
      this.down(e);
    }
  },

  onFocus: function onFocus() {
    this.setState({
      focused: true
    });
  },

  onBlur: function onBlur() {
    this.setState({
      focused: false
    });
  },

  render: function render() {
    var _rcUtil$classSet;

    var props = this.props;
    var prefixCls = props.prefixCls;
    var classes = rcUtil.classSet((_rcUtil$classSet = {}, _defineProperty(_rcUtil$classSet, prefixCls, true), _defineProperty(_rcUtil$classSet, props.className, !!props.className), _defineProperty(_rcUtil$classSet, prefixCls + '-disabled', props.disabled), _defineProperty(_rcUtil$classSet, prefixCls + '-focused', this.state.focused), _rcUtil$classSet));
    var upDisabledClass = '';
    var downDisabledClass = '';
    var value = this.state.value;
    if (isValueNumber(value)) {
      var val = Number(value);
      if (val >= props.max) {
        upDisabledClass = prefixCls + '-handler-up-disabled';
      }
      if (val <= props.min) {
        downDisabledClass = prefixCls + '-handler-up-disabled';
      }
    } else {
      upDisabledClass = prefixCls + '-handler-up-disabled';
      downDisabledClass = prefixCls + '-handler-up-disabled';
    }
    // ref for test
    return React.createElement(
      'div',
      { className: classes, style: props.style },
      React.createElement(
        'div',
        { className: prefixCls + '-handler-wrap' },
        React.createElement(
          'div',
          { unselectable: 'unselectable',
            ref: 'up',
            onClick: upDisabledClass ? noop : this.up,
            onMouseDown: preventDefault,
            className: prefixCls + '-handler ' + prefixCls + '-handler-up ' + upDisabledClass },
          React.createElement('a', { unselectable: 'unselectable', className: prefixCls + '-handler-up-inner', href: '#',
            onClick: preventDefault })
        ),
        React.createElement(
          'div',
          { unselectable: 'unselectable',
            ref: 'down',
            onMouseDown: preventDefault,
            onClick: downDisabledClass ? noop : this.down,
            className: prefixCls + '-handler ' + prefixCls + '-handler-down ' + downDisabledClass },
          React.createElement('a', { unselectable: 'unselectable', className: prefixCls + '-handler-down-inner', href: '#',
            onClick: preventDefault })
        )
      ),
      React.createElement(
        'div',
        { className: prefixCls + '-input-wrap' },
        React.createElement('input', { className: prefixCls + '-input',
          autoComplete: 'off',
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          onKeyDown: this.onKeyDown,
          autoFocus: props.autoFocus,
          readOnly: props.readOnly,
          disabled: props.disabled,
          max: props.max,
          min: props.min,
          name: props.name,
          onChange: this.onChange,
          ref: 'input',
          value: this.state.value })
      )
    );
  },

  setValue: function setValue(v, callback) {
    this.setState({
      value: v
    }, callback);
    this.props.onChange(v);
  },

  step: function step(type, e) {
    var _this = this;

    if (e) {
      e.preventDefault();
    }
    var props = this.props;
    if (props.disabled) {
      return;
    }
    var value = this.state.value;
    if (isNaN(value)) {
      return;
    }
    var stepNum = props.step || 1;
    var val = value;
    if (type === 'down') {
      val -= stepNum;
    } else if (type === 'up') {
      val += stepNum;
    }
    if (val > props.max || val < props.min) {
      return;
    }
    this.setValue(val, function () {
      React.findDOMNode(_this.refs.input).focus();
    });
  },

  down: function down(e) {
    this.step('down', e);
  },

  up: function up(e) {
    this.step('up', e);
  }
});

module.exports = InputNumber;


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-input-number/lib/InputNumber.js
 ** module id = 263
 ** module chunks = 0 1
 **/